import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { AlertTriangle } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

interface InsufficientCreditsModalProps {
  open: boolean;
  onClose: () => void;
  currentBalance: number;
  requiredCost: number;
}

const InsufficientCreditsModal = ({ open, onClose, currentBalance, requiredCost }: InsufficientCreditsModalProps) => {
  const navigate = useNavigate();

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <div className="flex items-center gap-3 mb-2">
            <div className="p-2 rounded-full bg-[hsl(var(--warning-light,48_96%_89%))]">
              <AlertTriangle className="h-6 w-6 text-amber-600" />
            </div>
            <DialogTitle className="text-lg">Insufficient Credits</DialogTitle>
          </div>
          <DialogDescription className="text-left">
            You don't have enough JobIntel 360 credits to generate this report.
          </DialogDescription>
        </DialogHeader>

        <div className="rounded-lg border border-[hsl(var(--card-border))] bg-[hsl(var(--background-secondary))] p-4 space-y-2">
          <div className="flex justify-between text-sm">
            <span className="text-muted-foreground">Your Balance</span>
            <span className="font-semibold text-foreground">{currentBalance} credits</span>
          </div>
          <div className="flex justify-between text-sm">
            <span className="text-muted-foreground">Report Cost</span>
            <span className="font-semibold text-destructive">{requiredCost} credits</span>
          </div>
          <div className="border-t border-[hsl(var(--card-border))] pt-2 flex justify-between text-sm">
            <span className="text-muted-foreground">Shortfall</span>
            <span className="font-bold text-destructive">{requiredCost - currentBalance} credits</span>
          </div>
        </div>

        <DialogFooter className="flex gap-2 sm:gap-2">
          <Button variant="outline" onClick={onClose}>
            Maybe Later
          </Button>
          <Button
            onClick={() => {
              onClose();
              navigate('/pricing');
            }}
            className="bg-[hsl(var(--primary))] text-[hsl(var(--primary-foreground))]"
          >
            Upgrade My Plan
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default InsufficientCreditsModal;
